exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".to-do .to-item[data-v-419fdb0f]{border-radius:0.10667rem}.marquee_box[data-v-419fdb0f]{position:relative;height:0.66667rem;overflow:hidden}.marquee_box.f-h[data-v-419fdb0f]{height:3.6rem}.marquee_box .marquee_list[data-v-419fdb0f]{display:block;position:absolute;top:0;left:0}.marquee_box .marquee_list li[data-v-419fdb0f]{line-height:0.33333rem}.marquee_box .marquee_top[data-v-419fdb0f]{-webkit-transition:all .5s;transition:all .5s;margin-top:-0.32rem}", ""]);

// exports
